import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {CountryISO, NgxIntlTelInputComponent, SearchCountryField} from 'ngx-intl-tel-input';
import {ValidableInputComponent} from '../validable-input/validable-input.component';

@Component({
  standalone: false,
  selector: 'app-tel-input',
  templateUrl: './tel-input.component.html',
  styleUrls: ['../validable-input/validable-input.component.scss', './tel-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TelInputComponent extends ValidableInputComponent implements OnInit {

  SearchCountryField = SearchCountryField;

  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.Spain];
  public selectedCountryISOVar = 'es';

  @ViewChild(NgxIntlTelInputComponent) private telComponent: NgxIntlTelInputComponent;

  @Input()
  formGroup: FormGroup;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getErrorText(): string {
    return 'INPUTS.ERRORS.TFN';
  }

  validation(value) {
    // No implementation
  }

  setCustomCountry(countryCode: string) {
    this.selectedCountryISOVar = countryCode;
    this.updateCountry();
  }

  updateCountry() {
    const country = this.telComponent?.allCountries.find(country => country.iso2 === this.selectedCountryISOVar.toLowerCase());
    if (country) this.telComponent.setSelectedCountry(country);
  }

}
